import { render, staticRenderFns } from "./modal-user-details.vue?vue&type=template&id=35288dea&"
import script from "./modal-user-details.vue?vue&type=script&lang=js&"
export * from "./modal-user-details.vue?vue&type=script&lang=js&"
import style0 from "./modal-user-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports